import { companyListRegisteredReducer } from "../reducer/CompanyListRegisteredReducer";

export const reducer = companyListRegisteredReducer;